import { SESSION_STORAGE_KEYS } from '@/constants/sessionStorageKeys';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/helpers/sessionStorage';

import { initialState } from './state';

const KEY = SESSION_STORAGE_KEYS.RENTAL_REQUEST_FLOW;

const isValidShape = s =>
  s != null &&
  typeof s === 'object' &&
  !Array.isArray(s) &&
  typeof s.query === 'string';

export const loadPersistedState = () => {
  const raw = getSessionStorageItem(KEY);
  return isValidShape(raw)
    ? { ...initialState, query: raw.query }
    : initialState;
};

export const persistState = state => {
  setSessionStorageItem(KEY, { query: state.query });
};
